﻿import React, { useState, useEffect, useRef } from "react";
import { Plus, Check, ChevronDown } from "lucide-react";
import { loadWatchlists, saveWatchlists } from "../../utils/watchlists.js";

export default function WatchButton({ ticker, user, onRequireLogin }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(() => loadWatchlists(user));
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const box = useRef(null);

  useEffect(() => {
    if (open) setData(loadWatchlists(user));
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => {
      if (box.current && !box.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const inAny = data.lists.some((l) => l.tickers.includes(ticker));
  const commit = (next) => {
    setData(next);
    saveWatchlists(user, next);
  };

  const toggle = (id) =>
    commit({
      ...data,
      lists: data.lists.map((l) =>
        l.id !== id ? l : { ...l, tickers: l.tickers.includes(ticker) ? l.tickers.filter((t) => t !== ticker) : [...l.tickers, ticker] }
      ),
    });

  const create = (e) => {
    e.preventDefault();
    const n = name.trim();
    if (!n) return;
    if (data.lists.some((l) => l.name.toLowerCase() === n.toLowerCase())) return setError("You already have a watchlist with that name.");
    const id = Date.now().toString(36);
    commit({ lists: [...data.lists, { id, name: n, tickers: [ticker] }], activeId: data.activeId || id });
    setName("");
    setError("");
  };

  const click = () => {
    if (!user) return onRequireLogin();
    setOpen((o) => !o);
  };

  return (
    <div ref={box} style={{ position: "relative", display: "inline-block" }}>
      <button className={`btn ${inAny ? "tool-btn" : "btn-purple"}`} onClick={click}>
        {inAny ? <Check size={15} /> : <Plus size={15} />} {inAny ? "In Watchlist" : "Add to Watchlist"} <ChevronDown size={14} />
      </button>
      {open && (
        <div
          style={{
            position: "absolute", right: 0, top: "calc(100% + 6px)", width: 260, zIndex: 1000,
            background: "#fff", border: "1px solid #ddd", borderRadius: 8, boxShadow: "0 6px 20px rgba(0,0,0,.15)", padding: 8, textAlign: "left",
          }}
        >
          <div className="small text-muted px-2 pb-1">Save {ticker} to:</div>
          {data.lists.length === 0 && <div className="small px-2 py-1 text-muted">You have no watchlists yet. Create one below.</div>}
          {data.lists.map((l) => {
            const on = l.tickers.includes(ticker);
            return (
              <label key={l.id} className="d-flex align-items-center gap-2 px-2 py-1" style={{ cursor: "pointer" }}>
                <input type="checkbox" checked={on} onChange={() => toggle(l.id)} />
                <span className="flex-grow-1">{l.name}</span>
                <span className="small text-muted">{l.tickers.length}</span>
              </label>
            );
          })}
          <form onSubmit={create} className="d-flex gap-1 mt-2 pt-2" style={{ borderTop: "1px solid #eee" }}>
            <input
              className="form-control form-control-sm"
              placeholder="New watchlist name"
              maxLength={40}
              value={name}
              onChange={(e) => { setName(e.target.value); setError(""); }}
            />
            <button type="submit" className="btn btn-purple btn-sm" disabled={!name.trim()}>Create</button>
          </form>
          {error && <div className="small text-danger px-1 pt-1">{error}</div>}
        </div>
      )}
    </div>
  );
}
